module.exports = __webpack_public_path__ + "img/136.862d0333.jpg";